import { isNil } from 'lodash-es';
import createNetworkingClient from 'utils/networking-client';
import { useCallback } from 'react';
import { devLog } from '../utils';

import { useFeedContext } from '../state/FeedContext';
import { UPDATE_RITMO_REGISTERED_IMPRESSIONS } from '../state/feed-actions';

const client = createNetworkingClient();

// TODO [fumba] remove once virtual feed is rolled out 100%
// TODO [fumba] unskip hook tests once virtual feed is rolled out 100%
const cache = [];

const useFeedRitmoCapping = () => {
  const { entityState, dispatch } = useFeedContext() || {
    entityState: {
      ritmoRegisteredImpressions: cache,
      isRestoringScrollPosition: false
    }
  }; // TODO [fumba] remove fallback once virtual feed is rolled out 100%
  const { ritmoRegisteredImpressions, isRestoringScrollPosition } = entityState;

  const errorState = (e) => {
    devLog(e);
    // TODO remove devLog and instead log error in sentry [monorepo]
  };

  const updateRitmo = useCallback(
    ({ elementId, path, promo, inView = true }) => {
      // do not track impressions for elements that are not in view and during feed scroll position restoration
      if (!inView || isRestoringScrollPosition) {
        return;
      }

      if (isNil(promo)) {
        errorState(new Error('promo name is required'));
        return;
      }
      if (isNil(elementId)) {
        errorState(new Error('element id is required'));
        return;
      }
      if (isNil(path)) {
        errorState(new Error('impression path is required'));
        return;
      }

      const key = `${promo}-${elementId}`;
      if (ritmoRegisteredImpressions.includes(key)) {
        return;
      }

      client
        .post(path, {
          promo
        })
        .then((response) => {
          if (response.status === 200) {
            if (dispatch) {
              // virtual feed
              dispatch({
                type: UPDATE_RITMO_REGISTERED_IMPRESSIONS,
                payload: { key }
              });
            } else {
              // HAML -react feed
              cache.push(key);
            }
          } else {
            errorState(response.error);
          }
        })
        .catch((e) => {
          errorState(e);
        });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [dispatch, ritmoRegisteredImpressions]
  );

  return { updateRitmo };
};

export default useFeedRitmoCapping;
